/**
 * Feature Flags Management
 * Centralized feature flag configuration
 */

export const featureFlags = {
  // Appointment V2 feature flag
  useAppointmentV2: {
    key: 'useAppointmentV2',
    default: true,
    description: 'Use the new appointment creation interface (V2)',
  },
  
  // Add more feature flags as needed
};

export function getFeatureFlag(flagName, defaultValue = false) {
  const key = featureFlags[flagName] ? featureFlags[flagName].key : flagName;
  const stored = localStorage.getItem(key);
  
  if (stored !== null) {
    return stored === 'true';
  }
  
  return featureFlags[flagName] ? featureFlags[flagName].default : defaultValue;
}

export function setFeatureFlag(flagName, value) {
  const key = featureFlags[flagName] ? featureFlags[flagName].key : flagName;
  localStorage.setItem(key, String(value));
}

export function enableFeatureForPercentage(flagName, percentage = 50) {
  // Enable feature for a percentage of users based on their ID
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  const userId = currentUser.id;
  
  if (!userId) return false;
  
  // Simple hash-based distribution
  const hash = userId.split('').reduce((acc, char) => {
    return acc + char.charCodeAt(0);
  }, 0);
  
  return (hash % 100) < percentage;
}



// WEBPACK FOOTER //
// ./src/utils/featureFlags.js